import React, {useState} from "react";
import './styles.scss';
import classNames from "classnames";
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext";
import {CONTROLLED_TEXT_INSERTION_COMMAND} from "lexical";
import {faSmile} from "@fortawesome/pro-regular-svg-icons";
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function NativeEmojiPlugin() {
    const [editor] = useLexicalComposerContext();
    const [visible, setVisible] = useState(false);
    function insertEmoji(emojiNative){
        editor.focus();
        editor.dispatchCommand(CONTROLLED_TEXT_INSERTION_COMMAND, emojiNative)
    }

    return <div className="lexical-emoji">
        {visible && (
            <div className="lexical-emoji-picker">
                <Picker
                    data={data}
                    previewPosition="none"
                    navPosition="bottom"
                    perLine={8}
                    locale="fr"
                    skinTonePosition="none"
                    //onClickOutside={()=>setVisible(false)}
                    onEmojiSelect={(emoji)=> {
                        insertEmoji(emoji.native);
                        setVisible(false)
                    }}/>
            </div>
        )}
        <div className={classNames("lexical-emoji-button", {active:visible})} onClick={()=>setVisible(!visible)}>
            <FontAwesomeIcon className="lexical-emoji-button-icon" icon={faSmile}/>
        </div>
    </div>
}

export default NativeEmojiPlugin